import React, {Component} from "react";
import "./index.scss"
import appinfo from "../../clientsJSON";
class Timeline extends Component {
    render(){
        return(
        <div>
            

<div className="timeline">
  <div className="container">
   {appinfo.media_news.map(i=>{return( 
  <div className="timeline-item">
       <div className="timeline-img"></div>
       {i%2==0&& <div className="timeline-content timeline-card js--fadeInRight">
        <div className="timeline-img-header" style={{background:`URL(${i.image_url}) center center no-repeat`}}>
          <h2>{i.title}</h2>
        </div>
   <div className="date">{i.date}</div>
   <p>{i.description}</p>
        <a href={i.link}className="bnt-more" >More</a>
      </div>}
      {i%2!=0&& <div className="timeline-content timeline-card js--fadeInRight">
        <div className="timeline-img-header" style={{background:`URL(${i.image_url}) center center no-repeat`}}>
          <h2>{i.title}</h2>
        </div>
   <div className="date">{i.date}</div>
   <p>{i.description}</p>
        <a href={i.link}className="bnt-more" style={{textDecoration:"none"}}>More</a>
      </div>}

    </div>   )})}
  </div>
</div>

            
        </div>
        )
    }
}
export default Timeline; 